<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useCreateSensorStore } from '@/store/createSensor'
import { ISensorFormData } from '@/interfaces/components/createSensor/create-sensor.ts'

import SchemaSelector from './SchemaSelector.vue'
import SchemaCreator from './SchemaCreator.vue'

const props = defineProps<{ modelValue: ISensorFormData }>()
const emit = defineEmits(['validate'])

const createStore = useCreateSensorStore()
const { isCreatingNewSchema } = storeToRefs(createStore)

const handleValidation = (isValid: boolean) => {
  emit('validate', isValid)
}
</script>

<template>
  <div class="w-full">
    <transition name="fade" mode="out-in">
      <SchemaCreator 
        v-if="isCreatingNewSchema"
        :sensor-type="modelValue.sensor_type" 
        @validate="handleValidation"
      />
      <SchemaSelector 
        v-else
        @validate="handleValidation"
      />
    </transition>
  </div>
</template>

<style scoped>
.fade-enter-active, .fade-leave-active { transition: opacity 0.2s ease; }
.fade-enter-from, .fade-leave-to { opacity: 0; }
</style>